import { getController } from '@/services/service'

const url = 'documentcontainer'

export const documentContainerService = {
	...getController<
		Api.DocumentContainer,
		Api.DocumentContainerPostInput,
		Api.DocumentContainerPostInput
	>(url),
}

export default documentContainerService
